import(/* webpackMode: "eager" */ "/app/src/app/(main)/chinh-sach-doi-tra/page.tsx");
